import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import { getAllData } from '../apis/generalApis'
import { Button } from '@mui/material'
import { ScaleLoader } from 'react-spinners'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const TermsAndConditionsModal = ({
  handleTermsAndConditionsModal,
  modalOpen = false,
  // setAcceptTermsAndConditions,
  screen = '',
}) => {
  const [termsAndConditions, setTermsAndConditions] = React.useState('')
  const [isLoading, setIsLoading] = React.useState(false)
  // const [
  //   acceptTermsAndConditions,
  //   setAcceptTermsAndConditions,
  // ] = React.useState(false)
  React.useEffect(() => {
    getTermsAndConditions()
  }, [])

  const getTermsAndConditions = async () => {
    try {
      setIsLoading(true)
      let result = await getAllData('show-terms-conditions')
      console.log(result?.data?.description)
      if (result?.data != null && result?.success === true) {
        setTermsAndConditions(result?.data?.description)
      }
    } catch (error) {
      console.error()
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={modalOpen}
        onClose={() => handleTermsAndConditionsModal(false)}
        // onBackdropClick={() => {
        //   return
        // }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width text-center">
          <h3 className="fs-24 mb-3 fw-bold">Terms & Conditions</h3>
          <div className="text-left">
            <p className="fs-16 font-weight-bold mb-1">Terms & Conditions</p>
            <p className="fs-14">{termsAndConditions}</p>
            <div
              className="mt-5 pointer"
              onClick={() => {
                if (screen === 'client-footer') {
                  handleTermsAndConditionsModal(false)
                  return
                }
                // setAcceptTermsAndConditions(true)
                handleTermsAndConditionsModal(false)
              }}
            >
              <Button
                id="btn-primary-no-shadow"
                className="pointer"
                fullWidth
                onClick={() => handleTermsAndConditionsModal(false)}
              >
                Continue
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default TermsAndConditionsModal
